import { NavLink, Link } from "react-router-dom";
import { Mail, Phone } from "lucide-react";
import { Sheet, SheetContent, SheetTitle } from "@/components/ui/sheet";
import { DEALER } from "@/data/dealer";
import { LogoImg } from "@/components/layout/Logo";
import { NAV } from "@/components/layout/nav";
import { todayName } from "@/lib/site";

export const MobileMenu = ({ open, onOpenChange }) => {
  const today = DEALER.hours.find((h) => h.day === todayName());
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent
        side="right"
        aria-describedby={undefined}
        data-lenis-prevent
        className="flex w-full flex-col gap-0 overflow-y-auto p-0 sm:max-w-md"
        data-testid="mobile-menu"
      >
        <SheetTitle className="sr-only">Menu</SheetTitle>
        <div className="flex h-16 items-center border-b border-line px-5">
          <LogoImg className="h-6" />
        </div>
        <nav aria-label="Mobile" className="flex flex-col px-5 py-4">
          {NAV.map((n, i) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.end}
              onClick={() => onOpenChange(false)}
              className={({ isActive }) =>
                `flex items-baseline gap-4 border-b border-line py-4 font-display text-2xl font-bold ${isActive ? "text-brand" : "text-ink"}`
              }
              data-testid={`mobile-nav-${n.id}-link`}
            >
              <span className="text-xs font-semibold tabular-nums text-steel">0{i + 1}</span>
              {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="mt-auto space-y-3 bg-paper px-5 py-6">
          <Link to="/used-cars" onClick={() => onOpenChange(false)} className="btn btn-primary w-full" data-testid="mobile-menu-view-stock-button">
            View Stock
          </Link>
          <div className="grid grid-cols-2 gap-3">
            <a href={DEALER.phone.href} className="btn btn-outline" data-testid="mobile-menu-call-link">
              <Phone aria-hidden="true" /> Call
            </a>
            <a href={`mailto:${DEALER.email}`} className="btn btn-outline" data-testid="mobile-menu-email-link">
              <Mail aria-hidden="true" /> Email
            </a>
          </div>
          {today && (
            <p className="pt-2 text-sm text-steel">
              Today ({today.day}): <span className="font-semibold text-ink">{today.hours}</span> · by appointment
            </p>
          )}
        </div>
      </SheetContent>
    </Sheet>
  );
};
